// utils/prefetchQuestionnaires.js
import axios from "axios";
import { db } from "./offlineDB";
import { env } from "../constants/env";

const formTypes = [
  "biosafety", 
  "infrastructure", 
  "logistics-supply", 
  "quality-management",
  "communication",
  "specimen-referral",
  "weekly-report"
];

export const prefetchAllQuestionnaires = async (labId) => {
  for (const formType of formTypes) {
    try {
      // Get the current offline version FIRST
      const localRecord = await db.questionnaires.get({ labId, formType });
      
      // Only fetch from server if we don't have offline data
      if (!localRecord?.offline) {
        const res = await axios.get(
          `${env.kataApiUrl}/api/questionnaire/${labId}/${formType}`
        );

        const serverData = res?.data || {};

        await db.questionnaires.put({
          labId,
          formType,
          ...serverData,
          offline: false,
          timestamp: Date.now(),
        });

        console.log(`[Prefetch] ${formType} saved from server`, serverData);
      } else {
        console.log(`[Prefetch] ${formType} has offline edits, skipping fetch`);
      }
    } catch (err) {
      console.warn(`[Prefetch] ${formType} failed:`, err.message);
    }
  }
};